import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { Box, Card, CardContent, Typography } from "@mui/material";
import React from "react";
import { colors } from "./theme";

interface KpiCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  trend?: {
    value: number;
    isPositive: boolean;
    period: "daily" | "weekly" | "monthly";
  };
  color?: string;
}

export const KpiCard: React.FC<KpiCardProps> = ({
  title,
  value,
  icon,
  trend,
  color = colors.accent1
}) => (
  <Card
    sx={{
      border: `1px solid ${colors.neutral2}20`,
      borderRadius: "8px",
      boxShadow: "none",
      height: "100%",
      transition: "all 0.2s ease-in-out",
      "&:hover": {
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
      }
    }}
  >
    <CardContent sx={{ pt: 3 }}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box>
          <Typography variant="body2" sx={{ color: colors.neutral3 }}>
            {title}
          </Typography>
          <Typography
            variant="h5"
            sx={{ fontWeight: 600, color: colors.primary }}
          >
            {value}
          </Typography>
          {trend && (
            <Box display="flex" alignItems="center" mt={0.5}>
              {trend.isPositive ? (
                <ArrowUpward sx={{ color: colors.success, fontSize: 16 }} />
              ) : (
                <ArrowDownward sx={{ color: colors.error, fontSize: 16 }} />
              )}
              <Typography
                variant="caption"
                sx={{
                  color: trend.isPositive ? colors.success : colors.error,
                  fontWeight: 500,
                  ml: 0.5
                }}
              >
                {trend.value}% {trend.isPositive ? "increase" : "decrease"}
                <span style={{ color: colors.neutral3 }}>
                  {" "}
                  ({trend.period})
                </span>
              </Typography>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            height: 48,
            width: 48,
            borderRadius: "50%",
            bgcolor: `${color}15`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          {React.cloneElement(icon as React.ReactElement, { sx: { color } })}
        </Box>
      </Box>
    </CardContent>
  </Card>
);
